export class ConfigsAreDifferentNotification
{
    constructor(json: object = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);
        }
    }

    public DeviceDescription: string;
    public DeviceId: number;
    public DeviceType: number;
    public DeviceUId: string;
    public StatusCode: number;
    public TypeCode: number;
    public LocationId: number;
    public Differences: DiffInfoItem[];
}

class DiffInfoItem {
        Item: string;
        ExpectedValue:number;
        ActualValue:number;
}
/*
    IdOfExpectedConfig,
    IdOfActualConfig,
    ResourceType,
    ConfigType,
    Comment
*/
